module.exports = __webpack_public_path__ + "img/aspas.43e291fc.svg";